module.exports = __webpack_public_path__ + "static/media/IMG_8849.bcdbb71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8849.jpg
// module id = 156
// module chunks = 0